import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { IAccountSettings } from './types'

export const useAccountSettingsStore = defineStore('accountSettings', () => {
  const accountId = ref('')
  const isClientUser = ref(false)
  const sessionToken = ref('')
  const inventoryIds = ref<number[]>([])
  const websiteUrl = ref('')
  const accountSettings = ref<IAccountSettings | null>(null)

  const setAccountSettings = (settings: IAccountSettings | null) => {
    // Set Account ID
    setAccountId(settings?.juid ?? '')

    // Set Inventory IDs
    const inventoryIds = settings?.a5Account ?? []
    const ensuredArrayOfIds = Array.isArray(inventoryIds)
      ? inventoryIds
      : String(inventoryIds)
        .split(',')
        .map((id: string) => id.trim())
    const ensuredNumberIds = ensuredArrayOfIds.map((id: string | number) =>
      Number(id),
    )
    setInventoryId(ensuredNumberIds)

    setWebsiteUrl(settings?.mainWebsite ?? '')

    // Store settings
    accountSettings.value = settings
  }

  const setIsClientUser = (value: boolean) => {
    isClientUser.value = value
  }

  const setSessionToken = (token: string) => {
    sessionToken.value = token
  }

  const getAccountSettings = (): any => {
    return accountSettings.value
  }

  const setAccountId = (newAccountId: string) => {
    accountId.value = newAccountId
  }

  const setInventoryId = (newInventoryIds: number[]) => {
    inventoryIds.value = newInventoryIds
  }

  const setWebsiteUrl = (url: string) => {
    websiteUrl.value = url
  }

  return {
    accountId,
    inventoryIds,
    isClientUser,
    sessionToken,
    websiteUrl,

    getAccountSettings,
    setAccountSettings,
    setIsClientUser,
    setSessionToken,
  }
})
